import type { ContactUsConfig } from '#types/config/components/form/contactUs'

export default {
  agreementCheckboxes: [
    {
      type: 'policy',
      required: true
    }
  ],
  category: '',
  email: '',
  firstName: '',
  hideFormBySubjectList: ['Repair request', 'How to request a warranty', 'Placing an order', 'Change or Cancel an Order', 'Promo codes', 'Exchange request', 'Request New Return Form', 'How to track my Order', 'Where is my Order', 'How do I return a product', 'Request Invoice'],
  lastName: '',
  message: '',
  orderNumber: '',
  phone: '',
  subject: ''
} satisfies ContactUsConfig
